import { Component, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { GoogleMapComponent } from '../../components/googlemap/googlemap';
import { CreateBookingPage } from '../bookings/my-bookings/create-booking/create-booking';
import { LatLng } from '../../entities/latlng';
import { NavController, NavParams } from 'ionic-angular';
import { Port } from '../../entities/port';
import { Route } from '../../entities/route';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';

@Component({
    selector: 'page-route-information',
    templateUrl: 'route-information.html',
})
export class RouteInformationPage {

    @ViewChild('mapContainer') mapContainerElement: ElementRef;
    @ViewChild('mapComponent') mapComponent: GoogleMapComponent;

    departurePort: Port;
    destinationPort: Port;
    route: Route;
    markers: LatLng[] = [];

    constructor(
        private navCtrl: NavController,
        private navParams: NavParams,
        private renderer: Renderer2,
        private spinner: SpinnerDialog,
    ) {
        this.route = this.navParams.get('route');

        if (this.route === undefined) return;
        if (this.route.ports === undefined || this.route.ports.length < 1) return;

        for (let port of this.route.ports) {
            if (port.location !== undefined)
                this.markers.push(port.location);
        }

        this.departurePort = this.route.getDeparturePort();
        this.destinationPort = this.route.getDestinationPort();
    }

    ionViewDidLoad() {
        let mapHeight = this.mapContainerElement.nativeElement.clientHeight;
        let mapWidth = this.mapContainerElement.nativeElement.clientWidth;
        this.renderer.setStyle(this.mapComponent.mapElement.nativeElement, 'height', mapHeight + 'px');
        this.renderer.setStyle(this.mapComponent.mapElement.nativeElement, 'width', mapWidth + 'px');
        this.mapComponent.initMap(mapWidth, mapHeight);
    }

    async bookUsingThisRoute() {
        this.spinner.show();
        this.navCtrl.push(CreateBookingPage, {
            route: this.route,
        });
        this.spinner.hide();
    }

    hasMarkers() {
        return this.markers.length > 0;
    }
}



// WEBPACK FOOTER //
// ./src/pages/route-information/route-information.ts